(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.service('thfFieldHelper', function() {
        return {
            identifier: '',
            // Love this answer: http://stackoverflow.com/a/2117523
            // Actually love the entire thread... very interesting read.
            formLabelIdentifier: function() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                    return v.toString(16);
                });
            },
            isValid: function(validationArray, key) {
                if( typeof validationArray !== 'undefined' ) {
                    if( typeof validationArray[key] !== 'undefined' ) {
                        return validationArray[key].result;
                    }
                }
                return true;
            },
            escapeValue: function(value) {
                if(typeof value === 'undefined' || value === null) {
                    return value;
                }
                return value
                    .replace(/\</g, '')
                    .replace(/\>/g, '')
                    .replace(/\"/g, '&quot;')
                    .replace(/\'/g, '&#x27;')
                    .replace(/\//g, '&#x2F;');
            },
            debugLog: function( fieldType, msg ) {
                if( console && console.log ) {
                    console.log('['+fieldType+']', msg );
                }
            }
        }
    });
})(jQuery, angular, window);
